module.exports = __webpack_public_path__ + "img/tema-3-28.e472d1fc.svg";